import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-projects-vobo-alerts-config',
  templateUrl: './projects-vobo-alerts-config.component.html',
  styleUrls: ['./projects-vobo-alerts-config.component.scss']
})
export class ProjectsVoboAlertsConfigComponent implements OnInit {

  selectedVobos: { id: number; nombre: string; }[] = [];
  alertsConfig: { id: number; texto: string; }[] = [];

  constructor(
    public dialogRef: MatDialogRef<ProjectsVoboAlertsConfigComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.selectedVobos = this.data.selectedVobos;
    // Clonamos para no modificar el original hasta guardar
    this.alertsConfig = JSON.parse(JSON.stringify(this.data.alertsConfig || []));

    // Sincronizamos la configuración de alertas con los vobos seleccionados
    this.syncAlerts();
  }

  ngOnInit(): void {
  }

  /**
   * Asegura que cada VoBo seleccionado tenga una entrada en alertsConfig.
   * Si un VoBo ya no está seleccionado, se elimina su configuración de alerta.
   */
  syncAlerts(): void {
    const selectedVoboIds = new Set(this.selectedVobos.map(v => v.id));

    // Eliminar alertas de vobos que ya no están seleccionados
    this.alertsConfig = this.alertsConfig.filter(alert => selectedVoboIds.has(alert.id));

    // Añadir entradas para nuevos vobos seleccionados
    this.selectedVobos.forEach(vobo => {
      if (!this.alertsConfig.some(alert => alert.id === vobo.id)) {
        this.alertsConfig.push({ id: vobo.id, texto: '' });
      }
    });
  }


  getAlertText(voboId: number): string {
    const alert = this.alertsConfig.find(a => a.id === voboId);
    return alert ? alert.texto : '';
  }


  updateAlertText(voboId: number, event: any): void {
    const alert = this.alertsConfig.find(a => a.id === voboId);
    if (alert) {
      alert.texto = event.target.value;
    }
  }

  clearAlertText(voboId: number): void {
    const alert = this.alertsConfig.find(a => a.id === voboId);
    if (alert) {
      alert.texto = '';
    }
  }


  save(): void {
    const configuredAlerts = this.alertsConfig.filter(a => a.texto && a.texto.trim() !== '');
    this.dialogRef.close(configuredAlerts);
  }


  cancel(): void {
    this.dialogRef.close();
  }
}
